<script lang="ts" setup>
import { PropType } from 'vue';
import { InvoiceLine } from '@/models/invoice';
import { formatCurrency, formatHours } from '@/filters/filters';

const { line } = defineProps({
  line: {
    type: Object as PropType<InvoiceLine>,
    required: true,
  },
});
</script>
<template>
  <tr class="invoice-detail">
    <td v-text="line.description"></td>
    <td class="invoice-hours">{{ formatHours(line.amount) }}</td>
    <td class="invoice-currency">
      <span>{{ formatCurrency(line.price) }}</span>
    </td>
    <td class="invoice-currency">
      <span>{{ formatCurrency(line.total) }}</span>
    </td>
  </tr>
</template>
